import { MainContent } from '@common/components/layout';
import { useCurrentRoute } from '@common/hooks';
import { Page } from '@hospital/components/layout';
import React from 'react'

export const UserProactivePrescriptionDetailsWrapper = ({ children }: React.PropsWithChildren) => {
  const currentRoute = useCurrentRoute();
  const pathname = currentRoute?.pathname?.toLowerCase() || '';
  const segments = pathname.split("/").filter(Boolean);
  const isNumberSegment = (value: string) => _.isNumber(Number(value)) && !_.isNaN(Number(value));

  if (segments[0] === "myprofile") {
    return <Page.Content>{children}</Page.Content>;
  }

  if (isNumberSegment(segments[0]) && segments[1] === "myhospital") {
    return <MainContent>{children}</MainContent>;
  }

  if ((isNumberSegment(segments[0]) && segments[1] === "myprofile") || segments[0] === "admin") {
    return (
      <Page>
        <Page.Content>{children}</Page.Content>
      </Page>
    );
  }

  return <MainContent>{children}</MainContent>;
};
